import { useEnrollmentStatuses } from './useEnrollmentStatuses';
import { useNotificationAudience } from './useNotificationAudience';
import { useNotificationMessage } from './useNotificationMessage';
import { useNotificationWizard } from './useNotificationWizard';

/**
 * Hook para gerenciar a etapa 3 do wizard — revisão e envio.
 * Agrega dados das etapas anteriores e expõe o estado de agendamento.
 *
 * @returns Resumo da notificação, estado de agendamento e handler de atualização
 *
 * @example
 * ```tsx
 * const { title, studentCount, schedule, updateSchedule } = useNotificationReview();
 * ```
 */
export function useNotificationReview() {
  const { wizardState, updateSchedule, goToStep } = useNotificationWizard();
  const { selectedStudentCount, selectedClassroomIds, selectedClassroomNames, selectedStatuses } =
    useNotificationAudience();
  const { title, body, url } = useNotificationMessage();
  const { enrollmentStatuses } = useEnrollmentStatuses();

  const statusLabels = selectedStatuses
    .map(id => enrollmentStatuses.find(s => s.id === id)?.label ?? id)
    .filter(Boolean);

  const classroomNameList = selectedClassroomIds.map(id => selectedClassroomNames[id] ?? id);

  return {
    title,
    body,
    url,
    studentCount: selectedStudentCount,
    classroomCount: selectedClassroomIds.length,
    statusCount: selectedStatuses.length,
    classroomNameList,
    statusLabels,
    schedule: wizardState.schedule,
    updateSchedule,
    goToMessageStep: () => goToStep(1),
  } as const;
}
